import { TRootState } from '../../common/reducers';
import { selectArticle } from '../../common/selectors/helpCenter';
import { selectHomepageContent, selectRecommendedArticles } from '../../common/selectors/homepage';
import { selectSolutions } from '../../common/selectors/solutions';
import { Page } from '../../common/types';
import {
  createArticleSolutionInfo,
  createHomepageSolutionInfo,
  createSearchResultsSolutionInfo,
} from '../solutionInfo';
import { SolutionInfo } from '../types';

export const solutionInfoPageMapper: Record<
  Page,
  (state: TRootState) => SolutionInfo | SolutionInfo[] | undefined
> = {
  [Page.Article]: (state) => {
    const article = selectArticle(state);
    return article ? createArticleSolutionInfo({ articleId: article?.id }) : undefined;
  },
  [Page.Search]: (state) => {
    const solutions = selectSolutions(state);
    return createSearchResultsSolutionInfo(solutions || []);
  },
  [Page.Home]: (state) => {
    const content = selectHomepageContent(state);
    const recommendedArticles = selectRecommendedArticles(state);
    return createHomepageSolutionInfo(content.data, recommendedArticles.data?.articles);
  },
  [Page.Chatbot]: () => undefined,
};
